import { type IDetailItemDicInfo } from '@interface/IDetail';
import classNames from 'classnames';
import { ProbabilityBtn } from './ProbabilityBtn';
import { SearchSvg } from './SearchSvg';

export const AdditionalEffects = ({ iteminfo }: { iteminfo: IDetailItemDicInfo }) => {
    if (!iteminfo.additional.count && !iteminfo.additional.effects) return null;

    return (
        <ul
            className={classNames({
                topborder: iteminfo.options?.length > 0 || iteminfo.subOptions.fixes?.length > 0 || iteminfo.subOptions.randoms?.length > 0,
            })}
        >
            {iteminfo.additional.effects.map((effect, idx) => (
                <li key={`additional-effect-${idx}`}>
                    <div className="value">{effect}</div>
                </li>
            ))}
            {!!iteminfo.additional.count && (
                <li>
                    <div className="value sub-ability">
                        추가 강화효과 {iteminfo.additional.count}개
                        <button data-tooltip-id="my-tooltip_additional">
                            <SearchSvg />
                        </button>
                    </div>
                    <ProbabilityBtn />
                </li>
            )}
        </ul>
    );
};
